import React from 'react';
import { Link } from 'react-router-dom';
import { Column, Section, Title, Container } from 'rbx';
import '../../styles/home.scss';
import presentationImage from '../../assets/images/presentation.png';
import Header from '../../components/components/Header';

function HomeScreen () {

  return (
    <>
      <Header />
      <Section size="medium" className="home">
        <Container className='is-max-widescreen'>
          <Column.Group>
            <Column size={6}>
              <Title size={1} className="has-text-white mb-6">
                {"<TransitarConsultoria />"}
              </Title>
{/*
              <Title size={1} className="has-text-white">
                A Transitar
              </Title>
              <Title subtitle size={2} className="has-text-white">
                Engenharia e Consultoria
              </Title>
*/}
              <Title size={5} spaced className="has-text-light" subtitle>
Da junção de ideias de um grupo de profissionais que buscavam ofertar serviços de alta qualidade de forma a atender, eficiente e dinamicamente, as demandas regionais e nacionais na complexa área da engenharia civil, surgiu a Transitar Engenharia e Consultoria.<br/><br/>

Esta empresa iniciou sua trajetória em meados de 2008, desenvolvendo projetos voltados à mobilidade urbana, figurando como uma das empresas pioneiras neste ramo na cidade de Fortaleza.
              </Title>
              <Column.Group>
                <Column>
                  <Link to="/login" className="button is-outlined is-white is-large is-fullwidth">
                    <strong>Entre Agora</strong>
                  </Link>
                </Column>
                <Column textAlign='right'>
                  <Link to="/activate" className="button is-outlined is-white is-large is-fullwidth">
                    <strong>Ative seu Usuário</strong>
                  </Link>
                </Column>
              </Column.Group>
            </Column>
            <Column size={6} textAlign='right'>
              <img src={presentationImage} alt="presentationImage" />
            </Column>
          </Column.Group>
        </Container>
      </Section>
    </>
  )

}

export default HomeScreen;
